import * as angular from "angular";

angular
  .module('bringoz.admin.planning')
  .constant('PlanningProjects_PN', {
    database: 'projects',
    isBranchEntity: true
  });
